import { regionCodes } from '../../referenceData';

export default (locCode) => !regionCodes.includes(locCode);
